import React, { Component } from 'react'
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';

export default class ViewofEmsStage1AuditReport extends Component {
    constructor(props) {
        super(props)

        this.state = {

            auditobservation: {
                orgCode: props.match.params.orgcode,
                emsauditreporturl: "",

            },
            data: {},
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedAuditObservationUrl: "",
            submitStatus: true,
            editStatus: false,
            showMessage: false,
            messageforvalidation: "none",
            uploadStatus: true,
            isLoading: false
        }
        this.viewAuditObservationUrlInput = React.createRef();


    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    handleRoute = () => {
        window.location.href = "/" + localStorage.getItem("role") + '/auditobservation/' + this.state.auditobservation.orgCode;
    }
    componentDidMount() {
        const api = APIURL + '/api/rfq/get/orgdetails/' + this.state.auditobservation.orgCode
        axios.get(api, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("token"),
            }
        })
            .then(res => {
                console.log("data ", res.data.response)
                this.setState({ data: res.data.response });
                if (res.data.response.auditPlanStatus) {
                    this.setState({ editStatus: true })
                    if (this.state.data.emsauditreporturl) {
                        console.log("if")
                        var uplodedFileName = this.state.data.emsauditreporturl.split("/")
                        var uplodedFileNameToView = uplodedFileName[4]
                        this.setState({ uploadedAuditObservationUrl: this.state.data.emsauditreporturl, uploadedFileNameToshow: uplodedFileNameToView })
                        this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block", downloadbuttonStatus: "none" })
                    }
                    else if (!this.state.data.emsauditreporturl) {
                        console.log("else if")
                        this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", downloadbuttonStatus: "block" })
                    }
                } else {
                    console.log("else")
                    this.setState({ editStatus: false, message: "Need to Fill the Audit Plan Data", showMessage: true })
                }
            })
            .catch(e => {
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);

                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                    //alert("if")
                    this.setState({ isLoading: true })
                }
            })
    }
    generatePdf = () => {
        return axios.get(APIURL + '/api/generatepdf/get/emsstage1auditreportpdf/' + this.state.auditobservation.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Ems Audit Report ' + `.pdf`
                link.click()
            })
    }
    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }
    handleauditobservation = (event) => {
        event.preventDefault();
        let newArr = this.viewAuditObservationUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        var file1 = Math.round((file.size / 1024));
        if (file1 <= 3072) {
            S3FileUpload
                .uploadFile(file, this.state.config)
                .then(data => {
                    var tempData = this.state.auditobservation;
                    tempData.emsauditreporturl = data.location
                    var docType = this.checkFileExtension(data.location)
                    var file = data.key.split("/")
                    var fileName = file[1];
                    this.setState({
                        emsauditreporturl: tempData,
                        showFile: docType,
                        uploadStatus: false,
                        messageforvalidation: "none",
                        fileToUpload: data.location,
                        filenameToview: fileName,
                        submitStatus: false
                    });
                })
                .catch(err => console.error(err))
        }
        else {
            this.setState({ filenameToview: "", messageforvalidation: "block" })
        }
    };
    postData = () => {
        var jsonRequest = {
            orgCode: this.state.auditobservation.orgCode,
            emsauditreportUrl: this.state.auditobservation.emsauditreporturl,
        }
        axios.patch(APIURL + "/api/rfq/patch/emsauditreporturl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    ToastInstance('Success', 'Ems Data Uploded')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    removeDoc = () => {
        var tempData = this.state.auditobservation;
        tempData.emsauditreportUrl = ""
        this.setState({
            auditobservation: tempData,
            uploadStatus: true,
        });
    }
    removeUplodedDoc = (id) => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest = {
                        "orgCode": this.state.auditobservation.orgCode,
                    }

                    axios.patch(APIURL + "/api/rfq/patch/deleteemsauditreporturl", jsonRequest)
                        .then((res) => {
                            if (res.data.errorCode === 0) {

                                this.setState({
                                    uploadDocumentStatus: "block",
                                    uploadedDocumentStatus: "none",
                                    uploadProcessUrl: "",
                                    uploadStatus: true,
                                    submitStatus: true,
                                    uploadedAuditObservationUrl: "",
                                    editStatus: true
                                })
                            }
                            else {
                                ToastInstance('Error', 'Something Went Wrong')
                            }
                        })
                        .catch(err => {
                            ToastInstance('warning', 'Something Went Wrong..Please Try again')
                        })

                }
            })
    }
    downloadUploadPdf = () => {
        const link = document.createElement('a');
        console.log("link", link)
        link.href = this.state.fileToUpload
        window.open(link)
    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link", link)
        link.href = this.state.uploadedAuditObservationUrl
        window.open(link)
    }
    render() {

        const FileReviewProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.auditobservation.emsauditreporturl} style={{ width: '80px', height: '80px' }} onClick={() => this.downloadUploadPdf()} />
                    <p>{this.state.filenameToview}</p>
                    <span>
                        <h6 onClick={() => this.removeDoc('emsauditreporturl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                    <div className="row">
                        <div className="col-sm-12">
                            <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadUploadPdf()} />

                            <span>
                                <h6 onClick={() => this.removeDoc('emsauditreporturl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                            </span>
                        </div>
                        <div className="row">
                            <span>{this.state.filenameToview}</span>

                        </div>
                    </div>
                    :
                    <>
                        <input type='file' ref={this.viewAuditObservationUrlInput} onChange={this.handleauditobservation} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if (this.state.isLoading) {
            return (<h1>Loading</h1>)
        }
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {
                                    this.state.showMessage ?

                                        <div className="text-center"><p style={{ fontSize: "25Px", color: "red" }}>{this.state.message}</p></div>
                                        :
                                        null
                                }
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "50px" }}>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Client Name</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize" >Address</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.address}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize" >Site Address</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.siteofaddress}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No. of employees</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.total}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Mobile</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.mobile}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Email</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.email}</p>                                                </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize" >Contact Person Name</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.contactPersonName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize" >Scope of Application</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.scope}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <div className="hrstyle headingcolor text-dark ">
                                                        <h5>Audit Team</h5>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-4 labelsize">Team Leader/ Lead Auditor</label>
                                                    <div className="col-sm-4">
                                                        <p>{this.state.data.teamleaderName}</p>
                                                    </div>
                                                </div>
                                                {
                                                    this.state.data.technicalExpertName ?
                                                        <div className="row  mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-4 labelsize">Technical Expert</label>
                                                            <div className="col-sm-4">
                                                                <p>{this.state.data.technicalExpertName}</p>
                                                            </div>


                                                        </div>
                                                        : ""
                                                }

                                                {
                                                    this.state.data.auditorOneName ?
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-4 labelsize">Auditor One</label>
                                                            <div className="col-sm-4">
                                                                <p>{this.state.data.auditorOneName}</p>
                                                            </div>
                                                        </div>
                                                        : ""
                                                }
                                                {
                                                    this.state.data.auditorTwoName ?
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-4 labelsize">Auditor Two</label>
                                                            <div className="col-sm-4">
                                                                <p>{this.state.data.auditorTwoName}</p>

                                                            </div>
                                                        </div>
                                                        : ""
                                                }
                                                <div className="row">
                                                    <div className="headingcolor hrstyle" >
                                                        <h5>Audit Mandays</h5>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize"> Stage 1 Mandays</label>
                                                    <div className="col-sm-3" >

                                                        <p>{this.state.data.stageOneAudit}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize"> Stage One Audit Date</label>

                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.auditdate1).format("DD-MM-YYYY")}</p>
                                                    </div>

                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize"> Stage 2 Mandays</label>

                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.stageTwoAudit}</p>

                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize"> Stage Two Audit Date</label>

                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.auditdate2).format("DD-MM-YYYY")}</p>

                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize">Date Of Audit From</label>

                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.dateofaudit).format("DD-MM-YYYY")}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-1 labelsize">Date Of Audit To</label>

                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.dateofauditto).format("DD-MM-YYYY")}</p>

                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize" >auditobjective</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.auditobjective}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize" >Brief about the organization</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.briefaboutorg}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div>
                                                        <div className="row mt-4">
                                                            <hr className="mt-4" />
                                                            <div className="col-sm-6 text-dark ">
                                                                <h5>Download Ems Audit Report</h5>
                                                            </div>
                                                            <div className="col-sm-4" />

                                                            <button className="btn btn-primary btn-sm col-sm-2 mb-2 ml-2" onClick={() => this.generatePdf()}>Download</button>

                                                            <hr />
                                                        </div>
                                                    </div>
                                                    {
                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                            ""
                                                            :
                                                            <div style={{ display: this.state.uploadDocumentStatus }}>
                                                                <div className="row mt-4">
                                                                    <hr className="mt-4" />
                                                                    <div className="col-sm-6 text-dark ">
                                                                        <h5>Upload Ems Audit Report </h5>
                                                                    </div>
                                                                    <hr />
                                                                    <div className="row mt-5" >
                                                                        <div className="col-sm-4"><label htmlFor="staticEmail" className="labelsize">Upload Stage1Ems Audit Report </label></div>
                                                                        <div className="col-sm-6">
                                                                            <p style={{ color: "red", display: this.state.messageforvalidation }}>Please Select Size Which is less than 3 MB</p>
                                                                            {
                                                                                this.state.auditobservation.emsauditreporturl !== "" ?
                                                                                    <FileReviewProcess />
                                                                                    :
                                                                                    <>
                                                                                        <input type='file' ref={this.viewAuditObservationUrlInput} onChange={this.handleauditobservation} />
                                                                                        <br></br>

                                                                                    </>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-sm-6" />
                                                                        <div className="col-sm-4" />
                                                                        <button type="button" className="btn btn-sm btn-success col-sm-2 mb-2 mr-2" onClick={() => this.postData()} disabled={this.state.submitStatus}>Upload</button>


                                                                    </div>

                                                                </div>

                                                            </div>
                                                    }
                                                    <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                        <div className="row mt-5" >
                                                            <hr className="mt-4" />
                                                            <div className="col-sm-6 text-dark ">
                                                                <h5>Uploaded Stage1 Ems Audit Report</h5>
                                                            </div>
                                                            <hr />
                                                            <div className="col-sm-4">

                                                                <label className="mt-4 labelsize">
                                                                    Uploaded Stage1 Ems Audit Report
                                                                </label>

                                                            </div>
                                                            <div className="col-sm-6">
                                                                {
                                                                    this.state.uploadedAuditObservationUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                        <>
                                                                            <img className="img-fluid" src={this.state.uploadedAuditObservationUrl} style={{ width: '80px', height: '80px' }} onClick={() => this.downloadSignedPdf()} />
                                                                            <p>{this.state.uploadedFileNameToshow}</p>
                                                                            {
                                                                                localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                                                    ""
                                                                                    :
                                                                                    <span>
                                                                                        <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                    </span>
                                                                            }
                                                                        </>
                                                                        :
                                                                        this.state.uploadedAuditObservationUrl.match(/\.(pdf)$/) ?
                                                                            <>
                                                                                <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadSignedPdf()} />

                                                                                {
                                                                                    localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                                                        ""
                                                                                        :
                                                                                        <span>
                                                                                            <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                        </span>
                                                                                }
                                                                                <p>{this.state.uploadedFileNameToshow}</p>
                                                                            </>

                                                                            :
                                                                            ""
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?

                                                            !this.state.uploadedAuditObservationUrl ?
                                                                <>


                                                                    <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>

                                                                </>

                                                                :
                                                                ""
                                                            :
                                                            ""

                                                    }
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {
                    localStorage.getItem("userRole") === "Management" || localStorage.getItem("userRole") === "Accounts" || localStorage.getItem("userRole") === "Executive(Support)" ?
                        ""
                        :

                        <div className="card-footer">
                            <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    {
                                        this.state.editStatus ?
                                            !this.state.uploadedAuditObservationUrl ?
                                                <button className="btn btn-primary float-right" onClick={() => this.handleRoute()}>Edit</button>
                                                :
                                                <div></div>
                                            : ""
                                    }
                                </div>
                            </div>
                        </div>
                }

            </div>
        )
    }
}
